import { Box, ButtonBase, Grid, Typography } from "@material-ui/core";
import { useStyles } from "./TopPage.styles";
import EmailIcon from "@material-ui/icons/Email";
import promzzy from "../../assets/images/promzzy.png";
import { socialLinks } from "../../utils/constants";

function TopPage() {
  const classes = useStyles();

  return (
    <Grid className={classes.topPageBg} xs={12}>
      <Grid className={classes.topContent} item xs={12}>
        <Grid>
          <Box className={classes.leftContent}>
            <ButtonBase className={classes.hello}>Hello I'm</ButtonBase>
            <Typography className={classes.myName}>Promise Stephen</Typography>
            <Typography className={classes.myStack}>
              Full Stack Software Engineer
            </Typography>
          </Box>
          <Box className={classes.socialMessagings}>
            <Typography className={classes.email}>
              <EmailIcon className="email-icon" />
              <span>promisestephen29@gmail.com</span>
            </Typography>

            <Box className={classes.socialLinks}>
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.url}
                  rel="noreferrer"
                  target="_blank"
                  className={classes.sociaLinkBtn}
                >
                  <link.icon className={classes.socialIcon} />
                </a>
              ))}
            </Box>
          </Box>
        </Grid>
        <Box className={classes.promzzyPix}>
          <img
            style={{ width: "100%", objectFit: "cover" }}
            src={promzzy}
            alt=""
          />
        </Box>
      </Grid>
    </Grid>
  );
}
export default TopPage;
